<mat-toolbar class="header">
  <div class="title">
    <mat-icon fontIcon="lock"></mat-icon>
    <span>{{'form.edit_password'|translate}}</span>
  </div>

  <span class="profil-spacer"></span>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted">
  </lib-button>
</mat-toolbar>

<form [formGroup]="pwdForm">
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>
      {{'form.old_password'|translate}}
    </mat-label>

    <input matInput formControlName="password" type="password">

    <mat-icon matSuffix>lock_outline</mat-icon>

    <mat-error *ngIf="pwdForm.controls['password'].hasError('required')">
      {{'form.required_field'|translate}}
    </mat-error>

    <mat-error *ngIf="pwdForm.controls['password'].hasError('incorrect')">
      {{'user.incorrect_password'|translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width" appearance="outline">
    <mat-label>
      {{'form.new_password'|translate}}
    </mat-label>

    <input matInput formControlName="newPassword" type="password" (input)="checkPasswordCriteria()">

    <mat-icon matSuffix>lock_outline</mat-icon>

    <mat-error *ngIf="pwdForm.controls['newPassword'].hasError('required')" class="error-text">
      *{{'form.required_field'|translate}}
    </mat-error>

    <mat-error *ngIf="pwdForm.controls['newPassword'].hasError('incorrect')" class="error-text">
      *{{'login.password_incorrect'|translate}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width" appearance="outline">
    <mat-label>
      {{'form.confirm_new_password'|translate}}
    </mat-label>

    <input matInput formControlName="_newPassword" type="password">

    <mat-icon matSuffix>lock_outline</mat-icon>

    <mat-error *ngIf="pwdForm.controls['_newPassword'].hasError('required')" class="error-text">
      *{{'form.required_field'|translate}}
    </mat-error>

    <mat-error *ngIf="pwdForm.controls['_newPassword'].hasError('incorrect')" class="error-text">
      *{{'form.compare_password'|translate}}
    </mat-error>
  </mat-form-field>

  <div class="password-criteria">
    <ul>
      <li [ngClass]="{'valid': passwordCriteria.length, 'invalid': reachedCriteria.length && !passwordCriteria.length}">
        Le mot de passe doit contenir au moins 8 caractères.
      </li>

      <li [ngClass]="{'valid': passwordCriteria.uppercase, 'invalid': reachedCriteria.uppercase && !passwordCriteria.uppercase}">
        Le mot de passe doit contenir au moins une lettre majuscule (A-Z).
      </li>

      <li [ngClass]="{'valid': passwordCriteria.lowercase, 'invalid': reachedCriteria.lowercase && !passwordCriteria.lowercase}">
        Le mot de passe doit contenir au moins une lettre minuscule (a-z).
      </li>

      <li [ngClass]="{'valid': passwordCriteria.digit, 'invalid': reachedCriteria.digit && !passwordCriteria.digit}">
        Le mot de passe doit contenir au moins un chiffre (0-9).
      </li>

      <li [ngClass]="{'valid': passwordCriteria.noSpaces, 'invalid': reachedCriteria.noSpaces && !passwordCriteria.noSpaces}">
        Le mot de passe ne doit pas contenir d'espaces.
      </li>
    </ul>
  </div>

  <mat-dialog-actions>
    <lib-button color="outline" icon="close" (click)="close()" text="{{'form.close'|translate}}">
    </lib-button>

    <lib-button color="primary" icon="save" text="{{'form.save'|translate}}" type="submit" (click)="savePassword()">
    </lib-button>
  </mat-dialog-actions>
</form>